import Sample from 'repos/Sample.js';
const TIMEOUT = 2000;

export function getSampleIdsFromSequence(sequence) {
    let samples = [];
    if ('subSequences' in sequence) {
        for (let i in sequence.subSequences) {
            let subSequence = sequence.subSequences[i];
            for (let j in subSequence.tracksData) {
                let trackData = subSequence.tracksData[j];
                samples = samples.concat(Object.keys(trackData.samplers));
            }
        }
    } else {
        for (let j in sequence.tracksData) {
            let trackData = sequence.tracksData[j];
            samples = samples.concat(Object.keys(trackData.samplers));
        }
    }

    return Array.from(new Set(samples));
}

export async function getSamples(sampleIds, encryptedIpfs, sleepTime) {
    let samples = {};

    for (let i in sampleIds) {
        let sampleId = sampleIds[i];
        try {
            let sample = await loadSample(encryptedIpfs, sampleId);
            samples[sampleId] = sample;
            await sleep(sleepTime / 2);
        } catch (err) {
            console.log('couldnt get sampleId = ' + sampleId);
            // console.log(err);
        }
    }

    console.log('finished getting samples');

    return samples;
}

async function sleep(time) {
    return new Promise(async (resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, time)
    });
}

function loadSample(encryptedIpfs, sampleId) {
    return new Promise(async (resolve, reject) => {
        setTimeout(() => {
            reject();
        }, TIMEOUT);

        let sample = new Sample(sampleId, encryptedIpfs);
        try {
            await sample.load();
            resolve(sample);
        } catch (e) {
            console.log('rejection from lod');
            reject();
        }
    });
}
